<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout wrap>
            <v-flex sm12 xs12 md12 lg12 grid-list-md>
                <v-form ref="formRecurso">
                    <v-flex xs12 md12>
                        <v-text-field v-model="procurar"
                            append-icon="mdi-magnify"
                            :label="inputProcurar"
                            single-line
                            hide-details/>
                    </v-flex>   

                    <v-data-table show-select v-model="selecionado" :search="procurar" class="elevation-1"
                        :headers="colunas" :items="tableItens" :footer-props="dataFooter">

                        <template v-slot:[`item.addDate`]="{ item }">
                            {{formatUtcToLocal(item.addDate)}}                              
                        </template>                         

                        <!-- <template v-slot:no-data>{{nenhumFormularioEncontrado}}</template> -->
                    </v-data-table>
                </v-form>   
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import ApiApplication from '@/api/identityProvider/application'

import ApiObject from '@/api/identityProvider/object'
import ApiObjectType from '@/api/identityProvider/object-type'

import ObjectTypeConstants from '@/constants/controle-acesso/object-type'

export default {
    name: "objeto-recurso",
    mixins: [ FormMixin, DateMixin ], 
    props: {
        value:{
            type: Object,
            required: false
        }        
    }, 
    watch:{
        selecionado(newValue){
            let formulario = this.$_.clone(this.value);
            formulario.resources = newValue; 
            this.$emit("input", formulario);
        }      
    },    
    data () {
        return { 
            recursoObjectType: null,
            selecionado: [],
            lista:{
                aplicacao: [],
                recurso: []
            },
            procurar: null,
            colunas: [
                { text: this.$t('Views.ControleAcesso.Formulario.Editar.aplicacao'), align: 'left', value: 'application.description' },
                { text: this.$t('Views.ControleAcesso.Formulario.Editar.codigo-unico'), align: 'center', value: 'uniqueCode' },
                { text: this.$t("Views.ControleAcesso.Formulario.Editar.descricao"), align: 'left', value: 'description' },  
                { text: this.$t('Views.ControleAcesso.Formulario.Editar.data-cadastro'), align: 'center', value: 'addDate' }
            ]                 
        }
    },   
    computed: {      
        tableItens(){
            if(this.lista.recurso == null || this.lista.recurso == undefined)
                return [];

            return this.lista.recurso;
        }, 
        inputProcurar(){
            return this.$t('Views.ControleAcesso.Formulario.Editar.procurar-recurso')            
        }                             
    },
    async mounted(){
        const loading = this.showLoading();
        await this.listarTipoObjetoRecurso();

        await this.listarAplicacao();
        await this.listarRecursos();

        loading.close();
    },     
    methods:{
        async listarAplicacao(){
            const resultado = await ApiApplication.listar().catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this.lista, "aplicacao", resultado.data);
            }
        },        
        async listarTipoObjetoRecurso(){
            const resultado = await ApiObjectType.listarPorCodigoUnico(ObjectTypeConstants.recurso).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                this.$set(this, "recursoObjectType", resultado.data);
            }
        },  
        async listarRecursos(){
            const resultado = await ApiObject.listarPorTipoObjeto(this.recursoObjectType.id).catch(erro => this.showSnackbarError(erro.error));
            if(resultado.success){
                const app = this.lista.aplicacao;
                resultado.data.forEach((element) => {
                    element.application = app.filter(a => a.id == element.application.id)[0];
                })                
                this.$set(this.lista, "recurso", resultado.data);
            }
        }        
    }       
}
</script>

<style lang="scss" scoped>
@import "../../../../styles/material-dashboard/variables";

</style>
